export default __webpack_public_path__ + "static/media/Farm-White.c011189b.png";